<span class="navn" data-testid="deltakernavn">{{ deltaker().medlem.navn }}</span>
<span class="rolle">{{ aktivRolleTittel() }}</span>
@if (visRepresentererKolonne()) {
  <span class="representasjoner">
    @if (deltaker().aksjeeierRepresentasjoner.length > 1) {
      <span class="aksjeeier multiple">
        <span class="representerer" (click)="toggleRepresentasjoner()" data-testid="vis-aksjeeiere">
          {{ 'Representerer' | translate }} ({{ deltaker().aksjeeierRepresentasjoner.length }})
          <mat-icon>{{ viserRepresentasjoner() ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </span>
        <span class="eierandel">{{ sumAndelIProsent() / 100 | percent }}</span>
      </span>
    }

    @if (viserRepresentasjoner()) {
      @for (aksjeeier of deltaker().aksjeeierRepresentasjoner; track aksjeeier.aksjeeierId) {
        <span class="aksjeeier">
          <span class="representerer">{{ aksjeeier.navn }}</span>
          <span class="eierandel">{{ aksjeeier.eierandel / 100 | percent }}</span>
        </span>
      }
    }
  </span>
}
<span class="kommentar" data-testid="kommentar">{{ deltaker().kommentar }}</span>
<span class="signatur" [matTooltip]="signeringsinformasjon()">
  @if (deltaker().harSignert) {
    <mat-icon inline="true">signature</mat-icon>
    {{ 'Signert' | translate }} {{ deltaker().signaturinformasjon?.signertDato | zoneddatetimeSomPlaindate | plaindate }}
  } @else if (deltaker().skalSignere) {
    {{ 'Ikke signert' | translate }}
  } @else {
    {{ 'Skal ikke signere' | translate }}
  }
</span>
